<template>
<div class="newFooterP">
    <p>(주)테이블엔조이 대표자 : 최종필</p>
    <p>사업자 등록 번호 : 113-86-37001</p>
    <p>서울특별시 구로구 디지털로26길 111 JNK디지털타워 401호</p>
    <p>통신판매업신고번호 : 제2010-서울구로-0541호</p>
    <p>개인정보 관리 책임자 : 최종필(privacy@tablenjoy.com)</p>

    <ul class="footerMenus">
        <li>
            <router-link :to='"/" + $route.params.sitename + "/user/service" '>이용약관</router-link>
        </li>
        <li> | </li>
        <li>
            <router-link :to='"/" + $route.params.sitename + "/user/privacy" '>개인정보 처리방침</router-link>
        </li>
    </ul>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    mounted(){
    },
    methods:{

    }
}
</script>

<style>
ul.footerMenus li {
    list-style: none;
    display: inline-block;
    font-weight: 600;
    cursor: pointer;
}

ul.footerMenus {
    margin-top: 20px;
}

</style>
